// third party
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RunsComponent } from '../runs/runs.component';
// local
import { DashboardComponent } from './dashboard/dashboard.component';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    RunsComponent
  ],
  exports: [
    DashboardComponent,
  ]
})
export class HomeModule { }
